import { render, staticRenderFns } from "./CustomerContactCard.vue?vue&type=template&id=9e9584fa"
import script from "./CustomerContactCard.vue?vue&type=script&lang=js"
export * from "./CustomerContactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports